module.exports = __webpack_public_path__ + "img/img4_8.44c5dec9.jpeg";